/** not | done | changed: whether the matching report's הוסף row holds the calculated amount. */
export const transferStatus = (amount, transferredAmount) => {
    if (transferredAmount === null || transferredAmount === undefined) return 'not';
    return Math.abs(Number(amount || 0) - Number(transferredAmount)) < 0.005 ? 'done' : 'changed';
};

export const transferStatusKey = (status) => `annualReport.expenseAdjustments.status.${status}`;

export const methodKey = (method) => `annualReport.expenseAdjustments.method.${method || 'none'}`;

/** "Vehicle name - license number". */
export const vehicleName = (item) => {
    const name = item.assetName
        || [item.vehicle?.manufacturerName, item.vehicle?.modelName].filter(Boolean).join(' ');
    return [name, item.vehicle?.licenseNumber].filter(Boolean).join(' - ');
};

/** Asset number and model: the line under the vehicle's name. */
export const vehicleSubtitle = (item) => [
    item.assetNumber,
    [item.vehicle?.manufacturerName, item.vehicle?.modelName].filter(Boolean).join(' '),
].filter(Boolean).join(' · ');

export const sumBy = (items, pick) => items.reduce((sum, item) => sum + Number(pick(item) || 0), 0);
